const CREATE_NEW = 'Create new';
const SAVE = 'Save';
const CREATE = 'Create';
const CLOSE = 'Close';
const MESSAGES_TITLE = 'Messages title';
const MESSAGES_TEXT = 'Messages text';
const USER = 'User';

const LINK_LIST = [
  {
    value: 'orderDetailsUrl',
    label: 'Order details',
    text: 'Order details',
  },
  {
    value: 'trackPageUrl',
    label: 'Track page',
    text: 'Track page',
  },
  {
    value: 'memoyaCloudLink',
    label: 'Cloud link',
    text: 'Cloud link',
  },
  {
    value: 'contactUsLink',
    label: 'Contact Page',
    text: 'Contact Page',
  },
  {
    value: 'proofPageLink',
    label: 'Proof page',
    text: 'Proof page',
  },
];

export {
  CREATE_NEW,
  SAVE,
  CREATE,
  CLOSE,
  LINK_LIST,
  MESSAGES_TITLE,
  MESSAGES_TEXT,
  USER,
};
